if (!customElements.get('pino-product-description')) {
  customElements.define('pino-product-description', class extends HTMLElement {
    connectedCallback() {
      if (!this.initialized && !this.initialize()) return;
      if (!this.preview) return;
      this.button.addEventListener('click', this.toggle);
      this.mobile.addEventListener('change', this.render);
      this.render();
    }

    initialize() {
      this.content = this.querySelector('[data-pino-description-content]');
      this.button = this.querySelector('[data-pino-description-toggle]');
      if (!this.content || !this.button) return false;
      this.initialized = true;
      const text = (this.content.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length <= 420) return true;
      const firstParagraph = Array.from(this.content.querySelectorAll('p')).find((paragraph) => paragraph.textContent.trim());
      const intro = (firstParagraph?.textContent || text).replace(/\s+/g, ' ').trim();
      this.preview = document.createElement('div');
      this.preview.className = 'pino-product-description__preview';
      this.preview.hidden = true;
      if (firstParagraph && intro.length <= 420) {
        const paragraph = firstParagraph.cloneNode(true);
        paragraph.removeAttribute('id');
        paragraph.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        this.preview.append(paragraph);
      } else {
        const paragraph = document.createElement('p');
        const excerpt = intro.slice(0, 420).replace(/\s+\S*$/, '').trim();
        paragraph.textContent = excerpt + (excerpt.length < intro.length ? '…' : '');
        this.preview.append(paragraph);
      }
      this.insertBefore(this.preview, this.content);
      this.label = this.button.querySelector('[data-pino-description-label]');
      this.symbol = this.button.querySelector('[data-pino-description-symbol]');
      this.expanded = false;
      this.mobile = window.matchMedia('(max-width: 639px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.render = () => {
        this.animation?.cancel();
        this.animation = null;
        const collapsed = this.mobile.matches && !this.expanded;
        this.content.hidden = collapsed;
        this.preview.hidden = !collapsed;
        this.button.hidden = !this.mobile.matches;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.label.textContent = collapsed ? this.button.dataset.readMore : this.button.dataset.readLess;
        this.symbol.textContent = collapsed ? '+' : '−';
      };
      this.toggle = () => {
        const previousPanel = this.content.hidden ? this.preview : this.content;
        const previousHeight = previousPanel.getBoundingClientRect().height;
        this.expanded = !this.expanded;
        this.render();
        const nextPanel = this.content.hidden ? this.preview : this.content;
        const nextHeight = nextPanel.getBoundingClientRect().height;
        if (this.mobile.matches && !this.reducedMotion.matches && nextPanel.animate && previousHeight > 0 && nextHeight > 0) {
          this.animation = nextPanel.animate(
            [
              { height: `${previousHeight}px`, opacity: .88, overflow: 'hidden' },
              { height: `${nextHeight}px`, opacity: 1, overflow: 'hidden' },
            ],
            { duration: 240, easing: 'cubic-bezier(.2, .7, .2, 1)' }
          );
        }
      };
      return true;
    }

    disconnectedCallback() {
      this.animation?.cancel();
      this.button?.removeEventListener('click', this.toggle);
      this.mobile?.removeEventListener('change', this.render);
    }
  });
}
